<template>
  <modal v-model="value.show" :large="true">
    <div slot="content">
      <div class="ls-modal-header">
        <button close-modal data-dismiss="modal">&times;</button>
        <h4 class="ls-modal-title">{{ $t('contracts.modal_taxes.title') }}</h4>
      </div>
      <div class="ls-modal-body">
        <h5 class="ls-title-3" v-if="unlinkedTaxes.length">{{ $t('contracts.modal_taxes.not_applied_taxes') }}</h5>
        <div class="ls-box max-heigth overflow-y-scroll" v-if="unlinkedTaxes.length">
          <table class="ls-table ls-sm-space ls-table-striped">
            <thead>
              <tr>
                <th>{{ $t('taxes.attributes.name') }}</th>
                <th>{{ $t('taxes.attributes.value') }}</th>
                <th>{{ $t('taxes.attributes.scope') }}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr data-test="tax" v-for="(tax, index) in unlinkedTaxes">
                <td data-test="tax.name">{{tax.name}}</td>
                <td data-test="tax.value" class="ls-no-padding-right">{{ (tax.value) }}%</td>
                <td data-test="tax.scope">{{ tax.scope}}</td>
                <td>
                  <authorized-link tag="create_contract_tax">
                    <button  @click.prevent="setContractTax(tax, index)" class="ls-btn ls-btn-primary ls-no-margin">
                        <i class="fa fa-plus" aria-hidden="true"></i>
                        <span class="ls-display-none-xs">{{ $t('contracts.modal_taxes.buttons.add') }}</span>
                    </button>
                  </authorized-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h5 class="ls-title-3" v-if="linkedTaxes.length">{{ $t('contracts.modal_taxes.applied_taxes') }}</h5>
        <div class="ls-box max-heigth overflow-y-scroll" v-if="linkedTaxes.length">
          <table class="ls-table ls-sm-space ls-table-striped">
            <thead>
              <tr>
                <th>{{ $t('taxes.attributes.name') }}</th>
                <th>{{ $t('taxes.attributes.value') }}</th>
                <th>{{ $t('taxes.attributes.scope') }}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr data-test="tax" v-for="(tax, index) in linkedTaxes">
                <td data-test="tax.name">{{ tax.name}}</td>
                <td data-test="tax.value" class="ls-no-padding-right">{{ (tax.value) }}%</td>
                <td data-test="tax.scope">{{ tax.scope}}</td>
                <td>
                  <authorized-link tag="destroy_contract_tax">
                    <button @click.prevent="disableContractTax(tax, index)" class="ls-btn ls-btn-danger ls-no-margin">
                      <i class="fa fa-trash" aria-hidden="true"></i>
                      <span class="ls-display-none-xs">{{ $t('contracts.modal_taxes.buttons.remove') }}</span>
                    </button>
                  </authorized-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="ls-modal-footer">
        <button class="ls-btn pull-right" close-modal data-dismiss="modal">{{ $t('application.button.close') }}</button>
      </div>
    </div>
  </modal>
</template>
<script>
  import Modal from 'src/app/components/shareds/modal/Modal'
  import { mapMutations, mapActions } from 'vuex'

  export default {
    props: ['value', 'linkedTaxes', 'unlinkedTaxes', 'save'],
    components: { Modal },
    methods: {
      ...mapMutations(['clearFlash', 'addFlash']),
      ...mapActions(['inactiveContract', 'createContractTax', 'inactivateContractTax']),
      setContractTax (tax, index) {
        this.$modalLoader.show()
        if (this.save) {
          let params = { tax_id: tax.id, contract_id: this.$parent.contract.id }
          this.createContractTax(params).then((response) => {
            this.$parent.contract.contract_taxes.push(response.data.contract_tax)
            this.toggleTaxes(this.linkedTaxes, this.unlinkedTaxes, tax, index)
          })
        } else {
          this.toggleTaxes(this.linkedTaxes, this.unlinkedTaxes, tax, index)
        }
      },
      toggleTaxes (toPush, toSplice, tax, index) {
        toPush.push(tax)
        toSplice.splice(index, 1)
        setTimeout(this.$modalLoader.hide, 500)
      },
      disableContractTax (tax, index) {
        this.$modalLoader.show()
        if (this.save) {
          let contractTax = this.findContractTax(tax.id)
          let params = { contract_tax_id: contractTax[0].id, contract_id: this.$parent.contract.id }
          this.inactivateContractTax(params).then(() => {
            this.toggleTaxes(this.unlinkedTaxes, this.linkedTaxes, tax, index)
          })
        } else {
          this.toggleTaxes(this.unlinkedTaxes, this.linkedTaxes, tax, index)
        }
      },
      findContractTax (taxId) {
        return this.$parent.contract.contract_taxes.filter(this.getContractTax.bind(this, taxId))
      },
      getContractTax (taxId, contractTax) {
        return contractTax.tax_id === taxId
      }
    }
  }
</script>
<style type="text/css">
  .max-heigth {
    max-height: 300px;
  }
  .overflow-y-scroll {
    overflow-y: scroll;
  }
</style>



// WEBPACK FOOTER //
// ModalTaxes.vue?5047ccf7